module.exports = __webpack_public_path__ + "img/promo-bg-desktop-xl.6541dc6.png";